import { render, staticRenderFns } from "./project_view.vue?vue&type=template&id=c120c506"
import script from "./project_view.vue?vue&type=script&lang=js"
export * from "./project_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports